<template>
  <div
    class="release-caution-area u-no-margin-top guest-caution-area">
    <div class="release-caution-area__title">【著作権管理サービスについて】</div>
    <div class="release-caution-area__paragraph">
      <div class="pad-l-b-1">
        著作権の100%を管理できていない作品や環境音のみを収録した非音楽著作物は、著作権管理サービスをご利用できません。
        <br>
        著作権管理サービスに登録できない作品は下記の通りです。
      </div>
      <ul class="c-indent-list">
        <li
          class="c-indent-list__node">
          生成AIソフトで制作した楽曲
        </li>
        <li
          class="c-indent-list__node">
          著作権管理団体へ登録済の楽曲
        </li>
        <li
          class="c-indent-list__node">
          第三者が権利を有する曲をサンプリング使用した楽曲
        </li>
        <li
          class="c-indent-list__node">
          環境音やノイズのみの楽曲
        </li>
        <li
          class="c-indent-list__node">
          オリジナルでない楽曲 (バージョン項目に表記がある楽曲)
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyrightCaution',
}
</script>
